<! --
/**
* SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
* Copyright (C) 2021 SuiteCRM Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<ng-container *ngIf="!isConfigured()">
    <scrm-label labelKey="LBL_BAD_GROUP_FIELD_CONFIG"></scrm-label>
</ng-container>

<ng-container *ngIf="isConfigured()">
    <div class="d-flex {{getDirection()}} justify-content-start align-items-end field-group h-100 composite-field-wrapper">

        <div *ngFor="let attribute of getAttributes()"
             [class.flex-fill]="mode ==='edit' && getDirection() === 'flex-row'"
             [class.align-self-start]="getDirection() === 'flex-row' && attribute.labelKey && showLabel(attribute)"
             class="field-group-item d-flex flex-column justify-content-end h-100 w-100">

            <!-- LABEL -->
            <span class="field-group-label pr-1"
                  [class.hidden]="!(attribute.labelKey && showLabel(attribute))">
                <label *ngIf="attribute.labelKey && showLabel(attribute)">
                    <scrm-label [labelKey]="attribute.labelKey" [module]="getModule()"></scrm-label>
                    <ng-container *ngIf="attribute?.required() && (['edit', 'create'].includes(mode))">
                        <span class="required">*</span>
                    </ng-container>
                </label>
            </span>

            <!-- VALUE -->
            <span *ngIf="attribute.type" class="field-group-field pr-1 pb-1 composite-field">

                <scrm-dynamic-field [componentType]="getComponentType(attribute.type, attribute.definition)"
                                    [field]="attribute"
                                    [klass]="klass"
                                    [mode]="getMode()"
                                    [originalMode]="originalMode"
                                    [record]="record"
                                    [parent]="parent"
                                    [type]="attribute.type">
                </scrm-dynamic-field>

            </span>
        </div>
    </div>
</ng-container>
